<mat-label class="subHeading">NOP</mat-label>
<div formGroupName="nop" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="3" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="3" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
